import { UPDATE_STATE_WITH_IDS } from "@live/store/LiveActions";
import { SET_IS_FLIGHT_FOCUS } from "@live/store/LiveMutations";
import { liveStore } from "@live/store/LiveStore";
import { defineComponent } from "vue";
export default defineComponent({
    computed: {
        servers: function () {
            const servers = liveStore.getters.getAllServersInfo;
            const percentage = (server) => Math.round(server.userCount / server.userMax * 100);
            return servers.map((value) => {
                return { id: value.id, text: `${value.name} (${value.userCount}/${value.userMax} - ${percentage(value)}%)` };
            });
        }
    },
    methods: {
        onClickServer: function (id) {
            liveStore.commit(SET_IS_FLIGHT_FOCUS, true);
            liveStore.dispatch(UPDATE_STATE_WITH_IDS, { serverId: id, flightId: null });
            this.$emit("onClose");
        }
    },
    emits: ["onClose"]
});
